import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';

/**
 * SilaNavTabs Component
 * @param {Array} tabs - An array of objects with shape:
 *   [{ key: string, label: string, component: ReactNode, permission: bool }]
 * @param {string} defaultTab - The key of the tab to show by default.
 */
function SilaNavTabs({ tabs, defaultTab }) {
  const [activeKey, setActiveKey] = useState(defaultTab || tabs[0]?.key || '');

  return (
    <div>
      <Nav
        className="px-4"
        variant="tabs"
        activeKey={activeKey}
        onSelect={(key) => setActiveKey(key)}
      >
        {tabs.map((tab) => (
          <Nav.Item key={tab.key}>
            <Nav.Link eventKey={tab.key} className={activeKey !== tab.key ? 'text-info' : ''}>
              <div className="px-3">{tab.label}</div>
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      <div className="mt-3">
        {tabs.map((tab) =>
          tab.key === activeKey ? (
            <div className="mt-3 px-4" key={tab.key}>
              {tab.component}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
}

export default SilaNavTabs;
